
import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    Dealer_Details,
    Attendences,
    Activity_Details,
    IsUserCheckout,
    Dealer_Activity_Types,
    NEW_ACTIVITY,
    GET_DEALER_BY_ID,
    RESCHEDULE_ACTIVITY,
    GET_SENIOR,
    APPROVE_AND_REJECT,
    TAGGED_ALONG_LIST,
    TAGGED_ALONG_BY_ID,
    ADD_TAGGED_ALONG,
    ACTIVITY_FILTER,
    MEETING_RATING,
    HEALTH_CARD,
    DEALER_PROFILE_DATA,
    GET_JUNIOR_LISTING_FOR_HOD,
    GET_SELF_LISTING,
    SAVE_RATING_FOR_HOD,
    EMAIL_DROPDOWN,
    SM_DETAILS_BY_USER_ID,
    RM_VIEW_DETAILS,
    STAR_CHECK,
    VERIFY_UCD_DEALER,
    UCD_DEALER_BY_ID,
    UCD_DEALER_SAVE,
    OTP_GENERATION,
    UCD_LIST,
    FIRM_TYPE,
    UCD_DEALER_UPDATE,
    GET_DEALER_POC,
    UPDATE_DEALER_POC,
    CAR_BRAND,
    CAR_MODEL,
    CAR_VARIANT,
    BANK_LIST,
    ADD_CASE,
    CASES_BY_LSQ_DEALER_ID,
    CASES_STATUS_UPDATE,
    CASE_LIST,
    CASE_BY_ID,
    LOAN_APPLICATION_BY_ID,
    LOAN_APPLICATION_UPDATE,
    PAYMENT_RAISE,
    LOAN_ACCOUNTS,
    LOAN_UNDERTAKING,
    APPROVAL_REQUEST,
    LOAN_TRANCHES,
    PAYMENT_RAISE_UPDATE,
    GET_PAYOUT_DETAILS,
    NEW_BANK_DETAILS,
    UPDATE_TRANCHE_STATUS,
    FORE_CLOSURE_ACCOUNT,
    VEHICLE_DETAILS,
    AGREEMENT_UCD_NOTIFICATION,
    AGREEMENT_UCD_VERIFIED,
    DEALER_APPROVED_LIST,
    RC_CASE_BY_ID
} from "./type";
import {fireEvent} from "../../component/MoEngage";


export const getDetails = (page = 1, searchValue = '', dealerType = 'ncd', limit = 15) => async (dispatch) => {
    const search = window.localStorage.search_account
    if(search){
       searchValue = search
    }

    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getDetails}?page=${page}&dealer_type=${dealerType}&limit=${limit}&search_key=${searchValue}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: Dealer_Details,
            payload: data.response.data,
        });
        return true;
    }
};

export const markAttendances = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.attendance}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: Attendences,
            payload: data.response,
        });
        return true;
    }
};

export const markAttendancesDealerLead = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.attendanceDealerLead}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: Attendences,
            payload: data.response,
        });
        return true;
    }
};

export const getActivity = (accountId, isDealerRequired = false) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.moduleActivity}?dealer_id=${accountId}&is_dealer_check=${isDealerRequired}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.moduleActivity}?dealer_id=${accountId}&is_dealer_check=${isDealerRequired}`,
        step: "api_request_success",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.moduleActivity}?dealer_id=${accountId}&is_dealer_check=${isDealerRequired}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.moduleActivity}?dealer_id=${accountId}&is_dealer_check=${isDealerRequired}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: Activity_Details,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.moduleActivity}?dealer_id=${accountId}&is_dealer_check=${isDealerRequired}`,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
    }
};

export const getActivityDealerLead = (leadId, isLeadCheck = false) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.moduleDealerLeadActivity}?lead_id=${leadId}&is_lead_check=${isLeadCheck}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.moduleDealerLeadActivity}?lead_id=${leadId}&is_lead_check=${isLeadCheck}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.moduleDealerLeadActivity}?lead_id=${leadId}&is_lead_check=${isLeadCheck}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.moduleDealerLeadActivity}?lead_id=${leadId}&is_lead_check=${isLeadCheck}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: Activity_Details,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.moduleDealerLeadActivity}?lead_id=${leadId}&is_lead_check=${isLeadCheck}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const userCheckout = (dearler_id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.isUserCheckout}?dealer_id=${dearler_id}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.isUserCheckout}?dealer_id=${dearler_id}`,
        step: "api_request_success",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.isUserCheckout}?dealer_id=${dearler_id}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.isUserCheckout}?dealer_id=${dearler_id}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: IsUserCheckout,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.isUserCheckout}?dealer_id=${dearler_id}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const userCheckoutDealerLead = (leadId, moduleType= 'Dealer') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.isUserDealerLeadCheckout}?lead_id=${leadId}&module_type=${moduleType}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.isUserDealerLeadCheckout}?lead_id=${leadId}&module_type=${moduleType}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.isUserDealerLeadCheckout}?lead_id=${leadId}&module_type=${moduleType}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.isUserDealerLeadCheckout}?lead_id=${leadId}&module_type=${moduleType}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: IsUserCheckout,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.isUserDealerLeadCheckout}?lead_id=${leadId}&module_type=${moduleType}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const activityTypes = (type = 'is_dealer', status = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dealerActivityTypes}?type=${type}&status=${status}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.dealerActivityTypes}?type=${type}&status=${status}`,
        step: "api_request_success",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.dealerActivityTypes}?type=${type}&status=${status}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.dealerActivityTypes}?type=${type}&status=${status}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: Dealer_Activity_Types,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.dealerActivityTypes}?type=${type}&status=${status}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};


export const newActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveActivityOnModules}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NEW_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const newActivityDealerLead = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveActivityOnDealerLead}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NEW_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const dealerById = (id, type) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dearlerById}?id=${id}&type=${type}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.dearlerById}?id=${id}&type=${type}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.dearlerById}?id=${id}&type=${type}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.dearlerById}?id=${id}&type=${type}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: GET_DEALER_BY_ID,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.dearlerById}?id=${id}&type=${type}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const rescheduleActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.rescheduleActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: RESCHEDULE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getSenior = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getSenior}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.getSenior}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        if(parseInt(data?.status_code) !== 200){
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.getSenior}`,
                step: "api_request_fail",
                page: window?.location?.pathname,
            });
        } else {
            fireEvent('debugging_event', {
                type: 'api_call',
                api_endpoint: `${Config.getSenior}`,
                step: "api_request_success",
                page: window?.location?.pathname,
            });
        }
        dispatch({
            type: GET_SENIOR,
            payload: data.response?.data,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.getSenior}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};


export const taggedAlongRejectOrApproval = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.UpdateTaggedAlong}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: APPROVE_AND_REJECT,
            payload: data.response,
        });
        return true;
    }
};

export const taggedAlongList = (page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.taggedAlongList}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TAGGED_ALONG_LIST,
            payload: data.response?.data,
        });
        return true;
    }
};

export const taggedAlongById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.taggedAlongById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TAGGED_ALONG_BY_ID,
            payload: data.response?.data,
        });
        return true;
    }
};

export const addTaggedAlong = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.addTaggedAlong}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ADD_TAGGED_ALONG,
            payload: data.response,
        });
        return true;
    }
};

export const getActivityFilter = (type = 'is_dealer') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.activityFilter}?type=${type}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACTIVITY_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const ratingSave = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post
        ,data,
        `${Config.meetingRating}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MEETING_RATING,
            payload: data,
        });
        return true;
    }
};

export const healthCard = (dealerId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dealerHeathCard}?dealer_id=${dealerId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: HEALTH_CARD,
            payload: data.response.data,
        });
        return true;
    }
};

// export const getjuniorListingForHod = (page=1, filterData = [{}]) => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.juniorListingForHod}?page=${page}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: GET_JUNIOR_LISTING_FOR_HOD,
//             payload: data.response?.data,
//         });
//         return true;
//     }
// };

export const getjuniorListingForHod = (page = 1, filterData = [{}]) => async (dispatch) => {
    let urls = `${Config.juniorListingForHod}?page=${page}`

    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_JUNIOR_LISTING_FOR_HOD,
            payload: data.response.data,
        });
        return true;
    }
};

export const getRmViewDetails = (page = 1, filterData = [{}]) => async (dispatch) => {
    let urls = `${Config.rmViewDetails}?page=${page}`

    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: RM_VIEW_DETAILS,
            payload: data.response.data,
        });
        return true;
    }
};

export const selfRatingDetails = (id = null, filterData = [{}]) => async (dispatch) => {
    let urls = `${Config.selfRatingDetails}?user_id=${id}`

    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_SELF_LISTING,
            payload: data.response.data,
        });
        return true;
    }
};

export const saveRatingForHod = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post
        ,data,
        `${Config.userRating}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_RATING_FOR_HOD,
            payload: data,
        });
        return true;
    }
};

export const checkStarForRating = (id=null) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.starCheck}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: STAR_CHECK,
            payload: data.response?.data,
        });
        return true;
    }
};

export const emailDropdownData = (type="hod") => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.emailDropdown}?type=${type}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: EMAIL_DROPDOWN,
            payload: data.response?.data,
        });
        return true;
    }
};

export const smDetailsByUserId = (id=null, page=1, isRating = 0) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.smByUserId}?user_id=${id}&page=${page}&is_rating=${isRating}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SM_DETAILS_BY_USER_ID,
            payload: data.response,
        });
        return true;
    }
};


export const healthcardDealerProfileData = (page=1, limit=null, dealerId, source, packageType, dealerSku) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dealerProfileData}?page=${page}&limit=${limit}&dealer_id=${dealerId}&source=${source}&package_type=${packageType}&dealer_sku=${dealerSku}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: DEALER_PROFILE_DATA,
            payload: data.response.data,
        });
        return true;
    }
};

export const verifyUCD = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.UCDVerify}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VERIFY_UCD_DEALER,
            payload: data.response,
        });
        return true;
    }
};

export const ucdById = (id=null) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.UCDDealerById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UCD_DEALER_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const ucdSave = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.ucdSave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UCD_DEALER_SAVE,
            payload: data.response,
        });
        return data;
    }
};

export const otpGenerate = (phoneNo) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.otpGenerate}?phone_no=${phoneNo}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OTP_GENERATION,
            payload: data.response,
        });
        return true;
    }
};

export const ucdList = (page=1, searchValue = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.ucdList}?search_key=${searchValue}&page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UCD_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const firmType = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.firmTypes}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FIRM_TYPE,
            payload: data.response?.data,
        });
        return true;
    }
};

export const ucdUpdate = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.ucdUpdate}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UCD_DEALER_UPDATE,
            payload: data.response,
        });
        return true;
    }
};

export const getDealerPocDetails = (dealerId) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.getDealerPoc}/${dealerId}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: GET_DEALER_POC,
        payload: data.response?.data,
      });
      return true;
    }
  };
  
  export const updateDealerPocDetails = (data, dealerId) => async (dispatch) => {
    console.log(dealerId)

    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.updateDealerPoc}/${dealerId}`
    );
    if (res) {
        console.log(res)

      const { data } = res;
      dispatch({
        type: UPDATE_DEALER_POC,
        payload: data.response,
      });
      return true;
    }
  };

export const carBrandRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carBrand}`
    );
    const {data} = res;
    dispatch({
        type: CAR_BRAND,
        payload: data?.response?.data,
    });
}

export const carModelRequest = (brandName) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carModel}?brand_name=${brandName}`
    );
    const {data} = res;
    dispatch({
        type: CAR_MODEL,
        payload: data?.response?.data,
    });
}

export const carVariantRequest = (modelName) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carVariant}?model_slug=${modelName}`
    );
    const {data} = res;
    dispatch({
        type: CAR_VARIANT,
        payload: data?.response?.data,
    });
}

export const bankListRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.bankList}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: BANK_LIST,
            payload: data?.response?.data,
        });
    } else {
        return res;
    }
}

export const addCaseRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.newCase}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: ADD_CASE,
            payload: data,
        });
    } else {
        return res;
    }
}

export const caseByLsqDealerIdRequest = (dealerId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.caseByLsqDealerId}?dealer_id=${dealerId}`
    );
    const {data} = res;
    dispatch({
        type: CASES_BY_LSQ_DEALER_ID,
        payload: data?.response?.data,
    });
}

export const caseStatusUpdateRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.updateCaseStatus}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: CASES_STATUS_UPDATE,
            payload: data,
        });
    } else {
        return res;
    }
}

export const caseListRequest = (dealerId, page = 1, filter = [{}], flow = '') => async (dispatch) => {
    let url = `${Config.caseListing}?page=${page}&dealer_id=${dealerId}&flow=${flow}`;

    Object.keys(filter[0]).map((val, i)=>{
        url+="&"+val+"="+filter[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    const {data} = res;
    dispatch({
        type: CASE_LIST,
        payload: data?.response?.data,
    });
}

export const caseByIdRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.caseById}?id=${id}`
    );
    const {data} = res;
    dispatch({
        type: CASE_BY_ID,
        payload: data?.response,
    });
}

export const loanApplicationByIdRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.loanApplicationById}?case_id=${id}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_APPLICATION_BY_ID,
        payload: data?.response,
    });
}

export const loanApplicationUpdateRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.loanApplicationUpdate}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_APPLICATION_UPDATE,
        payload: data?.response,
    });
}

export const loanPaymentRaiseRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.raisePayment}`
    );
    const {data} = res;
    dispatch({
        type: PAYMENT_RAISE,
        payload: data?.response,
    });
}

export const loanAccountRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.loanAccount}?id=${id}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_ACCOUNTS,
        payload: data?.response?.data,
    });
}

export const loanUndertakingRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.loanUndertaking}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_UNDERTAKING,
        payload: data?.response,
    });
}

export const loanApprovalRequestRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.approvalRequest}`
    );
    const {data} = res;
    dispatch({
        type: APPROVAL_REQUEST,
        payload: data?.response,
    });
}

export const loanTranchesRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.loanTranches}?id=${id}`
    );
    const { data } = res;
    dispatch({
        type: LOAN_TRANCHES,
        payload: data?.response?.data,
    });
};

export const loanPaymentRaiseUpdateRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.raisePaymentUpdate}`
    );
    const {data} = res;
    dispatch({
        type: PAYMENT_RAISE_UPDATE,
        payload: data?.response,
    });
}

export const updateThePayoutDetails = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.payoutDetailsUpdate}`
    );
    const {data} = res;
    dispatch({
        type: PAYMENT_RAISE_UPDATE,
        payload: data?.response,
    });
    return data?.response
}


export const getPayoutDetailsUsingId = (id) => async (dispatch) => {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.getPayoutDetails}?id=${id}`
        );

        if (res && res.data) {
            const { data } = res; 
            dispatch({
                type: GET_PAYOUT_DETAILS,
                payload: data?.data, 
            });
        } 
};

export const newBankDetailsRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.newBankDetails}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: NEW_BANK_DETAILS,
            payload: data?.response.data,
        });
    }
};

export const updateTrancheStatusRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.updateTrancheStatus}`
    );
    const {data} = res;
    dispatch({
        type: UPDATE_TRANCHE_STATUS,
        payload: data?.response,
    });
}

export const foreClosureAddAccountRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.foreClosureAccountDetails}`
    );
    const {data} = res;
    dispatch({
        type: FORE_CLOSURE_ACCOUNT,
        payload: data?.response,
    });
    return data?.response
}

export const vehicleDetailsRequest = (vehicleNo) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.vehicleDetails}?vehicle_no=${vehicleNo}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: VEHICLE_DETAILS,
            payload: data?.response,
        });
    }
};

export const ucdAgreementNotificationRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.agreementNotification}`
    );
    const {data} = res;
    dispatch({
        type: AGREEMENT_UCD_NOTIFICATION,
        payload: data?.response,
    });
}

export const checkAgreementVerifiedRequest = (id, aadharNo, business_name) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.checkAgreementVerified}?id=${id}&aadhar_no=${aadharNo}&business_name=${business_name}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: AGREEMENT_UCD_VERIFIED,
            payload: data?.response,
        });
    }
};

export const approvedListingForDealer = (page = 1, company_legal_name=null, id=null, status='') => async (dispatch) => {
    console.log("SEARCH: ", company_legal_name)
    let url = `${Config.getDealerApprovedListing}?page=${page}&status=${status}`;

    if(company_legal_name) {
        url += `&company_legal_name=${company_legal_name}`;
    }

    if(id) {
        url += `&id=${id}`;
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    const {data} = res;
    dispatch({
        type: DEALER_APPROVED_LIST,
        payload: data?.response?.data,
    });
}

export const rcCaseByIdRequest = (loanId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.rcCaseById}?loan_id=${loanId}&type=B2B`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: RC_CASE_BY_ID,
            payload: data?.response?.data,
        });
    }
};

